import type { PermissionRecord } from "@/types/permissions";
import { hasPermission } from "@/utils/permission-utils";
import type { AccountsDashboardStats, AccountsReceiptType } from "./types";

export const ACCOUNTS_RECEIPT_STREAM_PERMISSION: Record<AccountsReceiptType, string> = {
  sabil: "sabilReceipts.view",
  lagat: "lagatReceipts.view",
  booking: "bookingReceipts.view",
  niyaaz: "niyaazReceipts.view",
  yearlyNiyaaz: "yearlyNiyaazReceipts.view",
};

export type AccountsStreamAccess = Record<AccountsReceiptType, boolean>;

export function resolveAccountsStreamAccess(
  permissions: PermissionRecord | null | undefined
): AccountsStreamAccess {
  return {
    sabil: hasPermission(permissions, ACCOUNTS_RECEIPT_STREAM_PERMISSION.sabil),
    lagat: hasPermission(permissions, ACCOUNTS_RECEIPT_STREAM_PERMISSION.lagat),
    booking: hasPermission(permissions, ACCOUNTS_RECEIPT_STREAM_PERMISSION.booking),
    niyaaz: hasPermission(permissions, ACCOUNTS_RECEIPT_STREAM_PERMISSION.niyaaz),
    yearlyNiyaaz: hasPermission(permissions, ACCOUNTS_RECEIPT_STREAM_PERMISSION.yearlyNiyaaz),
  };
}

export function filterAccountsRecentReceipts(
  receipts: AccountsDashboardStats["recentReceipts"],
  access: AccountsStreamAccess
): NonNullable<AccountsDashboardStats["recentReceipts"]> {
  return (receipts ?? []).filter((row) => access[row.type] === true);
}
